import { useContext } from 'react';

import { context } from './context';
import { globalStore } from './store';

/**
 * Returns the correct store for the formy provider
 * If the store is not found, it returns the global store
 */
const useFormListStore = () => {
  const ctx = useContext(context);
  if (!ctx?.store) {
    return globalStore;
  }
  return ctx.store;
};

export { useFormListStore };
